import React from "react";
import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import BoxingTableContextMenu from "../ContextMenuItems/BoxingTableContextMenu";
import { HubHookFormInput } from "../../../components";

import { StyledCell, StyledWorkOrderStack } from "../styles";
import WorkOrderSelectField from "../WorkOrderSelectField";

const WorkOrderRoutingTableRow = ({
  idx,
  item,
  remove = () => {},
  disabled,
  options = [],
}) => {
  const prefix = `routes.${idx}`;

  const { getValues, setValue, watch } = useFormContext();

  const onDelete = () => remove(idx);

  const handleWorkOrderChange = () => {
    const routeId = getValues(`${prefix}.routeId`);
    const workOrder = options?.find((wo) => wo.id === routeId);
    const quantity = workOrder.available;
    setValue(`${prefix}.quantity`, quantity, { shouldValidate: true });
  };

  const routeId = watch(`${prefix}.routeId`);
  const workOrder = options?.find(({ id }) => routeId === id);
  const qty = workOrder?.quantity || 0;
  const endAdornment = qty ? `/${qty}` : "";

  const partNumber = workOrder?.part?.partNumber;
  const partName = workOrder?.part?.partName;

  return (
    <StyledWorkOrderStack>
      <WorkOrderSelectField
        name={`${prefix}.routeId`}
        defaultValue={item?.routeId}
        onChange={handleWorkOrderChange}
        disabled={disabled}
        options={options}
        required
      />
      <StyledCell sx={{ paddingLeft: "10px" }}>
        <Typography variant="caption11">{partNumber}</Typography>
      </StyledCell>
      <StyledCell sx={{ paddingLeft: "10px" }}>
        <Typography variant="caption11">{partName}</Typography>
      </StyledCell>
      <HubHookFormInput
        name={`${prefix}.quantity`}
        defaultValue={item?.quantity}
        disabled={disabled}
        placeholder="# of parts"
        endAdornment={endAdornment}
        required
        isNumber
      />
      <StyledCell>
        <BoxingTableContextMenu
          idx={idx}
          onDelete={onDelete}
          hideSerialize
          hideSplit
        />
      </StyledCell>
    </StyledWorkOrderStack>
  );
};

export default WorkOrderRoutingTableRow;
